import JobFilter from './JobFilter/job-filter';
import Utils from './JobFilter/Utils';
import MasonryUtils from './masonry-utils';

const PAGE = 1;
const PAGE_SIZE = 4;

export default class JobseekerHero {
    constructor(elm) {
        this.elm = elm;
        this.breakpoint = window.matchMedia('(min-width:992px)')?.matches;

        // Ensure required elements exist
        this.jobFilterNode = elm.querySelector('[data-job-filter-container]');
        this.jobsDisplayNode = elm.querySelector('[data-job-list-view]');
        this.gitterTemplate = elm.querySelector('[data-gitter-template]');
        this.gitterBtnTemplate = elm.querySelector('[data-gitter-btn-template]');

        // if they dont exist, stop execution with return
        if (!this.jobFilterNode || !this.jobsDisplayNode || !this.gitterTemplate || !this.gitterBtnTemplate) {
            //console.error('Error: Required elements are missing in the DOM.');
            return;
        }

        this.currentJobs = [];
        this.msonryUtils = new MasonryUtils();

        this.utils = new Utils({
            getPagination: this.getPagination.bind(this),
        });

        this.utils.addCallbackToOnFetchResult(
            this.onFetchJobsResult.bind(this),
        );

        this.jobFilters = new JobFilter(this.jobFilterNode, {
            utils: this.utils,
            setFetchResult: this.onFetchJobsResult.bind(this),
            getPagination: this.getPagination.bind(this),
            onReset: this.onResetFilters.bind(this),
            onSearchBtnClick: this.getFindJobUrlMobile.bind(this),
            fetchOnInit: false,
        });

        // Check if gitterBtnTemplate has content
        if (this.gitterBtnTemplate.content) {
            const filterLinkElement = this.gitterBtnTemplate.content.querySelector('[data-filter-link]');
            this.findJobUrl = filterLinkElement ? filterLinkElement.href : '';
        } else {
            //console.error('Error: gitterBtnTemplate content is null.');
            this.findJobUrl = ''; // Fallback to an empty string or some default URL
        }

        // Initialize masonry layout
        this.msonryUtils.reloadLayout();

        // Optionally, add a listener for changes in screen size
        this.setupMediaQueryListener();
    }

    setupMediaQueryListener() {
        const mediaQueryList = window.matchMedia('(min-width:992px)');
        mediaQueryList.addEventListener('change', (event) => {
            this.breakpoint = event.matches;
        });
    }

    getGitterBtnTemplate(addEmptyContainer = false) {
        const template = document.importNode(
            this.gitterBtnTemplate.content,
            true,
        );
        if (addEmptyContainer) {
            const bodyNode = template.querySelector('[data-container]');
            bodyNode.parentNode.removeChild(bodyNode);
        } else {
            template.querySelector('.see-more').classList.remove('see-more');
            template.querySelector('[data-filter-link]').href =
                this.getFindJobUrl();
        }
        return template;
    }

    getFindJobUrl() {
        const jobsFound = this.currentJobs?.length > 0;
        const urlParms = this.utils.getUrlParams()?.toString();
        return `${this.findJobUrl}${urlParms && jobsFound ? '?' + urlParms : ''}`;
    }

    getFindJobUrlMobile() {
        window.location.href = this.getFindJobUrl();
    }

    scrollToResultSection() {
        this.jobsDisplayNode.scrollIntoView({ behavior: 'smooth' });
    }

    onResetFilters() {
        this.jobsDisplayNode.textContent = '';
        this.currentJobs = [];
        this.msonryUtils.reset();
    }

    getPagination() {
        return { page: PAGE, pageSize: PAGE_SIZE };
    }

    getTemplateNode({
        jobNumber,
        jobType,
        jobTitle,
        jobTeaser,
        location: { zipCodes },
        company: { isAnonymous, name: companyName, logoUrl },
    }) {
        const template = document.importNode(this.gitterTemplate.content, true);
        const companyTitleNode = template.querySelector('[data-company-title]');
        const jobTitleNode = template.querySelector('[data-job-title]');
        const regionNode = template.querySelector('[data-region]');
        const jobTypeNode = template.querySelector('[data-job-type]');
        const companyLogoNode = template.querySelector('[data-logo]');
        const jobTeaserNode = template.querySelector('[data-description]');
        const jobLinkBtn = template.querySelector('[data-job-link]');

        companyTitleNode.textContent = isAnonymous ? '' : companyName;
        companyLogoNode.src = isAnonymous ? '' : logoUrl;
        jobTitleNode.textContent = jobTitle;
        regionNode.textContent = zipCodes?.length > 0 ? zipCodes[0].region : '';
        jobTypeNode.textContent = jobType?.length > 0 ? jobType[0].jobType : '';
        jobTeaserNode.textContent = jobTeaser;
        jobLinkBtn.href = jobLinkBtn.href + jobNumber;

        return template;
    }

    addJobsToDOM({ reset = false, addEmptyContainer = false }) {
        if (reset) {
            this.jobsDisplayNode.textContent = '';
        }
        const fragment = document.createDocumentFragment();
        this.currentJobs?.forEach((job) =>
            fragment.appendChild(this.getTemplateNode(job)),
        );

        // always add the see more node in the end
        // this.jobsDisplayNode.appendChild(fragment);
        if (addEmptyContainer) {
            fragment.appendChild(this.getGitterBtnTemplate(addEmptyContainer));
        }
        fragment.appendChild(this.getGitterBtnTemplate());
        this.jobsDisplayNode.appendChild(fragment);
    }

    onFetchJobsResult(fetchResult) {
        try {
            const { totalItems = 0, jobs = [] } = fetchResult;
            this.currentJobs = jobs;
            this.addJobsToDOM({
                reset: true,
                addEmptyContainer: totalItems < 2 && this.breakpoint,
            });
            this.currentJobs?.length > 0
                ? this.msonryUtils.reloadLayout()
                : this.msonryUtils.reset();
        } catch (error) {
            console.error(error);
        }
    }
}
